import React, { useEffect, useState } from "react";
import { CiSearch } from "react-icons/ci";
import { IoIosArrowRoundBack, IoMdEye } from "react-icons/io";
import { MdFilterAlt } from "react-icons/md";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import Pagination from "../../../components/common/Pagination";
import { FiEdit, FiTrash } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getAllBookings, getBookingDetail } from "../../../api/user/hotels";
import { reviewAdd } from "../../../api/user/restaurants";

const PopupModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed sm:inset-0 bottom-0 left-0 right-0 bg-black bg-opacity-50 flex sm:items-center items-end justify-center z-50 h-full">
      <div className="bg-white sm:rounded-[20px] rounded-t-[20px] w-full sm:w-[978px] relative sm:shadow-lg">
        <button
          onClick={onClose}
          className="absolute top-[33px] right-[30px] text-[#9E9E9E] hover:text-black"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
};

const ForRestaurants = () => {
  const [showReviewModal, setShowReviewModal] = React.useState(false);
  const [selectedOrder, setSelectedOrder] = React.useState(null);
  const [rating, setRating] = React.useState(0);
  const [comment, setComment] = React.useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [status, setStatus] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const statuses = ["Confirmed", "Pending", "Canceled"];
  const queryClient = useQueryClient();
  const [page, setPage] = useState(1);
  const limit = 10;
  const navigate = useNavigate();
  const [selectedBookingId, setselectedBookingId] = useState(null);
  const [enabled, setEnabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    tableNo: "",
    discountPercentage: "",
    tokenCharges: "",
    bookingStatus: "available",
  });

  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["bookings", page, limit],
    queryFn: () => getAllBookings({ page, limit }),
    keepPreviousData: true,
  });

  const { data: OrdersDetailData, isLoading: isOrderDetailLoading } = useQuery({
    queryKey: ["rbookings-detail", selectedBookingId],
    queryFn: () => getBookingDetail(selectedBookingId),
    enabled: !!selectedBookingId && isPopupOpen,
    keepPreviousData: true,
  });

  const orders = data?.data?.bookings || [];
  const pagination = data?.data?.pagination || {};
  const orderDetail = OrdersDetailData?.data?.booking;

  const handleFilterChange = (value) => {
    setStatus(value);
    setIsOpen(false);
  };

  const openModel = (id, status) => {
    setselectedBookingId(id);
    setFormData((prev) => ({
      ...prev,
      bookingStatus: status,
    }));

    setIsPopupOpen(true);
  };

  const reviewMutation = useMutation({
    mutationFn: reviewAdd,
    onSuccess: () => {
      toast.success("Review submitted successfully");
      queryClient.invalidateQueries("bookings")
      queryClient.invalidateQueries("rbookings-detail")
      setShowReviewModal(false);
      // setIsPopupOpen(false)
      setSelectedOrder(null);
      setRating(0);
      setComment("");
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || "Failed to submit review.");
    },
  });

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 mt-[30px]">
      <div className="flex justify-between items-center flex-wrap gap-[20px] mt-[20px]">
        <div className="flex gap-[10px] items-center">
          <div className="w-[32px] h-[32px] bg-[#4CAF50] rounded-[50%] flex items-center justify-center hover:bg-[#FF9D00]">
            <IoIosArrowRoundBack
              onClick={() => navigate(-1)}
              size={24}
              className="text-[#fff]"
            />
          </div>
          <h2 className="text-[22px] font-medium">Hotel Bookings</h2>
        </div>
        <div className="relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="py-[9px] px-[35px] bg-white text-base  font-medium flex  items-center gap-[6px] rounded-[2px] border border-[#DDDDDD]"
          >
            <MdFilterAlt /> {status || "Filter"}
          </button>
          {isOpen && (
            <div className="absolute z-10 mt-2 w-36 bg-white border rounded shadow text-sm font-medium">
              {statuses.map((item) => (
                <div
                  key={item}
                  onClick={() => handleFilterChange(item)}
                  className="px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                >
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <div className="mt-[31px]">
        <div className="rounded-[10px] border border-[#D9D9D9] overflow-hidden mt-[28px] py-[20px] sm:px-[30px] px-[15px] bg-white">
          <div className="flex justify-between items-center py-[13px] flex-wrap  gap-[10px]">
            <h2 className="text-base font-semibold">Hotel Bookings list </h2>
            <div className="relative w-full max-w-[301px]">
              <span className="absolute inset-y-0 left-3 flex items-center">
                <CiSearch size={24} className="text-[#4CAF50]" />
              </span>
              <input
                type="text"
                placeholder="Search.."
                className="w-full pl-10 pr-4 py-2 rounded-full border border-[#DDDDDD] focus:outline-none focus:border-[#4CAF50]"
              />
            </div>
          </div>

          {isLoading ? (
            <div className="flex justify-center py-12">
              <div className="w-12 h-12 border-4 border-green-500 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : isError ? (
            <p className="text-red-500 text-center mt-6">{error.message}</p>
          ) : (
            <div className="overflow-x-auto md:mt-[30px] mt-[20px]">
              <table className="min-w-full  ">
                <thead className="bg-[#FFFAF2] ">
                  <tr className="">
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Booking ID
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Hotel Name
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Guest Name
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Room Number
                    </th>

                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Check-in date
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] max-w-[197px] whitespace-nowrap">
                      Check-out Date
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Number of Guests
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Booking Status
                    </th>
                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] max-w-[168px] whitespace-nowrap">
                      Payment
                    </th>

                    <th className="text-left text-lg font-medium text-[#000000] py-[24px] px-[16px] whitespace-nowrap">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {orders?.length > 0 &&
                    orders?.map((order) => {
                      return (
                        <tr className="border-t border-[#E4E4E4] ">
                          <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                            {order?.bookingId}
                          </td>
                          <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                            {order?.hotelId?.name}
                          </td>
                          <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                            {order?.userId?.name}
                          </td>
                          <td className="py-[20px] px-[16px] text-base font-normal text-black  whitespace-nowrap">
                            {order?.rooms}
                          </td>

                          <td className="py-[20px] px-[16px] ">
                            {order?.checkInDate &&
                              new Date(order?.checkInDate).toLocaleDateString(
                                "en-GB"
                              )}
                          </td>
                          <td className="py-[20px] px-[16px] text-base text-black  whitespace-nowrap">
                            {order?.checkOutDate &&
                              new Date(order?.checkOutDate).toLocaleDateString(
                                "en-GB"
                              )}
                          </td>
                          <td className="py-[20px] px-[16px] ">
                            {order?.guests}
                          </td>
                          <td className="py-[20px] px-[16px]">
                            <div
                              className={`px-[28px] py-2 w-max font-normal rounded-full text-center text-sm 
      ${order?.bookingStatus?.toLowerCase() === "pending" ||
                                  order?.bookingStatus?.toLowerCase() === "awaiting payment"
                                  ? "bg-yellow-500 text-white"
                                  : order?.bookingStatus?.toLowerCase() === "booked"
                                    ? "bg-[#4CAF50] text-white"
                                    : order?.bookingStatus?.toLowerCase() === "cancelled"
                                      ? "bg-red-500 text-white"
                                      : "bg-gray-300 text-black"
                                }
    `}
                            >
                              {order?.bookingStatus}
                            </div>
                          </td>
                          <td className="py-[20px] px-[16px] ">
                            {order?.paymentStatus}
                          </td>

                          <td className="py-[20px] px-[16px]  flex gap-[12px]">
                            <a
                              href="#"
                              onClick={() =>
                                openModel(order?._id, order?.bookingStatus)
                              }
                              className="text-black font-normal w-[32px] h-[32px] flex items-center justify-center rounded-full bg-[#F2F2F2] "
                            >
                              <IoMdEye className="text-base text-black" />
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
          {orders?.length > 0 && (
            <Pagination
              page={pagination.currentPage}
              totalPages={pagination.totalPages}
              setPage={setPage}
            />
          )}
        </div>
      </div>

      <PopupModal isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)}>
        <div className="w-full rounded-[20px] md:p-[30px] py-[20px] px-[15px]">
          <div className="grid grid-col-1 sm:grid-cols-3 justify-between text-left pb-[21px] border-b border-[#EEEEEE] mb-[18px]">
            <h2 className="text-[22px] font-medium col-span-2">
              Booking Detail{" "}
            </h2>

            {
              (orderDetail?.hasReview == false && orderDetail?.bookingStatus === "checked-out") && (
                <span
                  onClick={() => {
                    setSelectedOrder(orderDetail);
                    setShowReviewModal(true);
                  }}
                  className="inline-block mt-2 px-4 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800 hover:bg-green-200 hover:text-green-900 cursor-pointer transition duration-200 shadow-sm hover:shadow-md"
                >
                  Review
                </span>
              )
            }


          </div>
          <div className="h-[350px] overflow-y-auto">
            <p className="text-[17px] font-medium mb-[15px]">
              For Booking ID: {orderDetail?._id} - {orderDetail?.userId?.name}'s
              Booking
            </p>
            <div className="border border-[#DDDDDD] rounded-[5px] xl:gap-[47px] gap-[20px] p-[20px] pb-[36px] bg-white grid lg:grid-cols-[auto_auto_1fr] md:grid-cols-2 grid-cols-1">
              <div>
                <h2 className="text-[17px] font-medium text-black">
                  Booking Information {orderDetail?.hasReview} {orderDetail?.bookingStatus}
                </h2>
                <ul className="mt-5">
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Booking ID:</span>
                    {orderDetail?._id}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Name:</span>
                    {orderDetail?.userId?.name}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Total Guests:</span>
                    {orderDetail?.guests}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">CheckIn Date:</span>{" "}
                    {orderDetail?.checkInDate &&
                      new Date(orderDetail?.checkInDate).toLocaleDateString(
                        "en-GB"
                      )}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">CheckOut Date: </span>
                    {orderDetail?.checkOutDate &&
                      new Date(orderDetail?.checkOutDate).toLocaleDateString(
                        "en-GB"
                      )}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Rooms: </span>
                    {orderDetail?.rooms}
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="text-[17px] font-medium text-black">
                  Payment Information
                </h2>
                <ul className="mt-5">
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Payment Method:</span>
                    {orderDetail?.paymentMethod}
                  </li>
                  <li className="text-[17px]  mb-[10px] text-[#FF9D00]">
                    <span className="font-medium text-[#757474]">
                      Payment Status:
                    </span>{" "}
                    {orderDetail?.paymentStatus}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Sub Total :</span> ₾
                    {orderDetail?.subtotal}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Discount:</span> ₾
                    {orderDetail?.discountAmount}
                  </li>
                  <li className="text-[17px] text-[#757474] mb-[10px]">
                    <span className="font-medium">Total :</span> ₾
                    {orderDetail?.totalAmount}
                  </li>
                </ul>
              </div>
              <div>
                <h2 className="text-[17px] font-medium text-black">
                  Booking Status
                </h2>
                <ul className="mt-5">
                  <li className="text-[17px]  mb-[10px] text-[#FF9D00]">
                    <span className="font-medium text-[#757474]">
                      Current Status:
                    </span>{" "}
                    {orderDetail?.bookingStatus}
                  </li>
                  <li className="text-[17px]  mb-[10px] text-[#FF9D00]">
                    <span className="font-medium text-[#757474]">Notes:</span>{" "}
                    {orderDetail?.notes}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </PopupModal>

      {showReviewModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-xl w-full max-w-md shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-center">
              Write a Review
            </h2>

            {/* Star Rating */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Rating
              </label>
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((star) => {
                  const isFilled = star <= rating;
                  return (
                    <svg
                      key={star}
                      onClick={() => setRating(star)}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill={isFilled ? "#facc15" : "#e5e7eb"}
                      stroke={isFilled ? "none" : "black"}
                      strokeWidth={isFilled ? "0" : "1"}
                      className="w-7 h-7 cursor-pointer hover:scale-110 transition-transform duration-150"
                    >
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.23 3.776a1 1 0 00.95.69h3.982c.969 0 1.371 1.24.588 1.81l-3.222 2.34a1 1 0 00-.364 1.118l1.23 3.776c.3.921-.755 1.688-1.538 1.118l-3.222-2.34a1 1 0 00-1.176 0l-3.222 2.34c-.783.57-1.838-.197-1.538-1.118l1.23-3.776a1 1 0 00-.364-1.118L2.27 9.203c-.783-.57-.38-1.81.588-1.81h3.982a1 1 0 00.95-.69l1.23-3.776z" />
                    </svg>
                  );
                })}
              </div>

            </div>

            {/* Comment Input */}
            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Comment
              </label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                rows="4"
                placeholder="Write your feedback here..."
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowReviewModal(false);
                  setSelectedOrder(null);
                  setRating(0);
                  setComment("");
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300 transition"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (!rating || !comment) {
                    toast.error("Please provide both rating and comment.");
                    return;
                  }
                  reviewMutation.mutate({
                    bookingId: selectedOrder?._id,
                    rating,
                    comment,
                  });
                }}
                disabled={reviewMutation.isLoading}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
              >
                {reviewMutation.isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}


      {/* {showReviewModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md">
            <h2 className="text-xl font-semibold mb-4">Write a Review</h2>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Rating
              </label>
              <select
                value={rating}
                onChange={(e) => setRating(Number(e.target.value))}
                className="w-full border border-gray-300 rounded px-3 py-2"
              >
                <option value="">Select rating</option>
                {[1, 2, 3, 4, 5].map((star) => (
                  <option key={star} value={star}>
                    {star} Star{star > 1 && "s"}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Comment
              </label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                className="w-full border border-gray-300 rounded px-3 py-2"
                rows="4"
                placeholder="Write your feedback here..."
              />
            </div>

            <div className="flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowReviewModal(false);
                  setSelectedOrder(null);
                  setRating(0);
                  setComment("");
                }}
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  if (!rating || !comment) {
                    toast.error("Please provide both rating and comment.");
                    return;
                  }
                  reviewMutation.mutate({
                    bookingId: selectedOrder?._id,
                    rating,
                    comment,
                  });
                }}
                disabled={reviewMutation.isLoading}
                className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
              >
                {reviewMutation.isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default ForRestaurants;
